export const randomPrompts = [
	'A surreal cityscape at sunset with floating islands.',
	'A futuristic metropolis with flying cars and neon lights.',
	'A steampunk-inspired underwater world with mechanical sea creatures.',
	'A garden of oversized flowers with candy-colored petals.',
	'An enchanted forest with trees that emit bioluminescent light.',
	'A dessert-themed landscape made of giant candy and ice cream mountains.',
	'A cyberpunk street scene with holographic advertisements and augmented reality elements.',
	'A serene lakeside cabin surrounded by mountains and waterfalls.',
	'A post-apocalyptic wasteland with towering sand dunes and abandoned buildings.',
	'A retro-futuristic space station orbiting a colorful gas giant planet.',
	'A whimsical tea party with animals dressed in elegant Victorian clothing.',
	'An otherworldly alien marketplace with bizarre creatures selling exotic goods.',
	'A magical library with floating books and staircases that defy gravity.',
	'A prehistoric jungle with dinosaurs and primitive human settlements.',
	'A time-traveling adventure featuring ancient ruins and modern skyscrapers blending together.',
	'A microscopic world with living cells as bustling cities and organisms as characters.',
	'A celestial scene of constellations coming to life and interacting with each other.',
	'A high-tech greenhouse where robotic plants are tended by tiny robotic gardeners.',
	'A dramatic volcanic eruption with molten lava and dramatic fiery skies.',
	'A haunted mansion with ghostly figures and hidden passages.',
	'A ballet performance where dancers have bodies made of water.',
	'A hidden underwater civilization with transparent domes and marine life.',
	'A carnival in the clouds with floating rides and cotton candy clouds.',
	'A mountain range made of giant crystals reflecting vibrant colors.',
	'A journey through a pixelated digital world with glitchy landscapes.',
	'A colony on a distant planet with futuristic architecture and alien flora.',
	'A journey through a psychedelic landscape filled with swirling patterns and colors.',
	'A parallel universe where gravity works in unexpected ways.',
	'A fusion of organic and mechanical elements in a biomechanical landscape.',
	'An intergalactic archaeological dig uncovering ancient artifacts from alien civilizations.',
];
